import { React } from "react";
import { Link, useNavigate } from "react-router-dom";

function ForumTopic({ id, name, icon, postCount }) {
  const navigate = useNavigate();

  const handleNavigatePost = (id) => {
    navigate(`/app/topics/${id}/posts`)
  }
 
  return (
    <article className="flex gap-4 items-center p-4 border-b border-gray-200 max-sm:flex-col max-sm:items-start cursor-pointer"  onClick={() => {
      handleNavigatePost(id)
    }}>
      <div className="flex flex-1 gap-4 items-center max-sm:w-full">
        <div className="flex justify-center items-center p-4 bg-rose-600 rounded-[400px]">
          {icon}
        </div>
        <h3 className="flex-1 gap-1 text-base font-semibold leading-7 text-gray-700">
          {name}
        </h3>
      </div>
      <div className="text-md font-semibold text-blue-600">
        {postCount}
      </div>
      {/* <div className="flex flex-col gap-0.5 w-[280px] max-sm:w-full">
        <Link
          to={() => {
            handleNavigatePost(id)
          }}
          className="gap-1 text-sm font-semibold leading-6 text-blue-500"
        >
          {name}
        </Link>
        <div className="flex gap-1 items-start">
          <span className="text-sm font-medium leading-6 text-zinc-600">
            from
          </span>
          <a href="#" className="text-sm font-medium leading-6 text-blue-500">
            {123}
          </a>
        </div>
        <div className="flex gap-1 items-center">
          <span className="mx-1">•</span>
          <time className="text-sm leading-6 text-gray-400">
            {123}
          </time>
          <span className="mx-1">•</span>

          <time className="text-sm leading-6 text-gray-400">
            {123}
          </time>
        </div>
      </div> */}
    </article>
  );
}

export default ForumTopic;
